import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 48
}

/**
 * Stateless function representing a PRO 2020 icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <Pro2020Icon width={48} />
 */
const Pro2020Icon = props => (
    <SvgIcon {...props}>
        <path
            d={`M41.44,15.73a2.88,2.88,0,0,0-1-1.59A3.89,3.89,0,0,0,39,13.53C36.83,13,24.56,13,24,13s-12.82,0-15,
                .54a4,4,0,0,0-1.44.6,2.88,2.88,0,0,0-1,1.6,46,46,0,0,0-.59,8v.67a45,45,0,0,0,.59,7.85,2.8,2.8,0,0,0,1,
                1.64A4,4,0,0,0,9,34.41c1.87.45,11,.6,15,.6s13.14-.15,15-.6a3.88,3.88,0,0,0,1.39-.57,2.85,2.85,0,0,0,
                1-1.63A46.4,46.4,0,0,0,42,24.36v-.67A47.55,47.55,0,0,0,41.44,15.73ZM29.28,30.16H11.7V17.67H29.28Z`}
        />
    </SvgIcon>
)

Pro2020Icon.defaultProps = defaultProps

export { Pro2020Icon }
